import { createI18nText } from "@hilma/netina2all";

const stationPurhcasesText = createI18nText({
    he: {
        title: 'הזמנות',
        entityName: 'תחנה',
        stillEditing: <>התחנה עדיין לא פתוחה.<br />תוכל/י לראות את הרכישות בתחנה כאשר היא תאושר.</>,
        status: {
            open: 'פתוחה להזמנות',
            close: 'סגורה להזמנות',
            inactive: 'תחנה לא פעילה',
        },
        kitsNums: {
            sold: 'מוצרים נמכרו בתחנה זו',
            outOf: 'מתוך יעד של',
            kits: 'מוצרים',
            rised: 'גויסו מהיעד',
        },
        table: {
            list: 'רשימת הזמנות',
            mark: 'סמן את ההזמנות שחולקו',
            download: 'הורד רשימת הזמנות',
            th: {
                name: 'שם',
                phone: 'טלפון',
                holders: 'מספר הנרתיקים',
            },
            noResults: 'לא נמצאו הזמנות',
            noResultFilter: 'כל ההזמנות בתחנה זו חולקו'
        },
        pdfExcel: {
            choose: 'איך תרצה להוריד את הרשימה?',
            downloadAs: 'הורד כ',
            pageTitle: 'דוח הזמנות',
            numOfRows: 'מספר שורות',
            distText: 'חולקה',
            yes: 'כן',
            no: 'לא',
        },
        generalTitle: 'פרטי הזמנות כלליים'
    },
    en: {
        title: 'Orders',
        entityName: ' station',
        stillEditing: <>The station is still closed.<br />You would be able to see the purchases of the station when it will be approved.</>,
        status: {
            open: 'Open',
            close: 'Closed',
            inactive: 'Inactive',
        },
        kitsNums: {
            sold: 'kit sold in this station',
            outOf: 'Out of a goal of',
            kits: 'kits',
            rised: 'rised from the goal',
        },
        table: {
            list: 'List of Orders',
            mark: 'Mark the orders that have been distributed',
            download: 'Download list of orders',
            th: {
                name: 'Name',
                phone: 'Phone',
                holders: 'Holders Number',
            },
            noResults: 'No orders found',
            noResultFilter: 'Every order in this station has been distributed'
        },
        pdfExcel: {
            choose: 'How would you like to download the list?',
            downloadAs: 'Download as',
            pageTitle: 'Orders Report',
            numOfRows: 'Number of Rows',
            distText: 'Distributed',
            yes: 'Yes',
            no: 'No',
        },
        generalTitle: 'General Orders Details'
    }
});

export default stationPurhcasesText;